<template>
  <div class="my-care">
    <router-view></router-view>
    <div class="nav-menu" v-if="ShowCareBar">
      <span @click="tabSwitch(0)" :class="{actived: currentTabIndex == 0 }"><i class="nav-care-menu-ico-1"></i>无忧卡</span>
      <span @click="tabSwitch(1)" :class="{actived: currentTabIndex == 1 }"><i class="nav-care-menu-ico-2"></i>申请记录</span>
    </div>
  </div>
</template>

<script>
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";
// const { publicPath } = process.env.CONFIG;
// const projectUrl = window.location.origin + publicPath;

const TabRoutePath = ['/care/list', '/care/apply/record'];

const YActAlert = (resolve) =>
  require(["../../components/YActAlertDialog.vue"], resolve); // 领取无忧使用的提示窗

const NormalAlert = (resolve) =>
  require(["../../components/NormalAlert.vue"], resolve); // 续费和过期使用的提示窗

export default {
  name: "MyCare",
  data() {
    return {
      isWechat: this.$store.state.isWechat,
      currentTabIndex:0,
      user: {
        name: "",
        phone: "",
        avatar: require("../../assets/ic_default_avatar.png"),
      },
      cares: [],
      showActivateCareDialog: false,
      tips: [], // 需要弹窗提醒消息数组
      currentTipsIndex: 0, // 当前提醒消息索引 
      currentTipsMessage: null, // 当前提醒消息
      showTips: true, 
      useAlert: null
    };
  },
 computed: {
   ShowCareBar() {
     return this.$store.state.ShowCareBar;
   }
 },
  created() {
    this.initCurrentTabIndex();
  },
  methods: {
    initCurrentTabIndex(){
      for (let index = 0; index < TabRoutePath.length; index++) {
        const tabPath = TabRoutePath[index];
        const currentPath = this.$route.path;
        if(currentPath.indexOf(tabPath) > -1) {
          this.currentTabIndex = index;
          break;
        }
      }
    },
    initUserInfo() {
      const info = this.$store.state.userInfo;
      if (!info) {
        // login(this.$store, this.$router);
        return;
      }
      this.user = {
        avatar: info.avatar || require("../../assets/ic_default_avatar.png"),
        name: info.name || "",
        phone: info.phone || "",
      };
    },
    async loadMyCare() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetUserCardList", {
          type: "post",
          body: { CustomerMobilePhone: this.user.phone },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast("加载失败，请稍后重试");
        } else {
          this.cares = ret.Data.map(this.resultMapper);

          if (!this.cares || this.cares.length == 0) return;

          // 只有一张卡 && 卡可以续费
          if (this.cares.length == 1 && this.cares[0].canRenew) {
            this.gotoRenewDetail(this.cares[0]);
          } else {
            let cards = this.cares.filter((c) => c.renewCard && c.status != -20); // 弹窗提醒指针对可续费卡(体验卡)
            // 保证弹框的顺序
            await this.setActiveCard(cards);
            await this.setRenewCard(cards);
            await this.setExpiredCard(cards);
            this.executeTips();
          }
        }

        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    resultMapper(data) {
      const supportnew = 1; // 是否支持续费
      return {
        id: data.sysNo,
        type: data.ServiceType,
        endTime: data.FailureTime && new Date(data.FailureTime + "+08:00"),
        imei: data.IMEICode,
        status: data.CardStatus,
        audit: data.AuditStatus,
        name: data.ServiceTypeName,
        single: !data.EquityVal || data.EquityVal.length <= 1,
        code : data.ActivationCode,
        effectiveDay: data.EffectiveDay,
        img: data.CardLogo,
        renewCard: data.IsSupportRenew == supportnew, // 可续费卡
        canRenew: data.IsSupportRenew == supportnew && data.CardStatus == 20, // 当前是否可以续费(卡已激活 && 可续费卡)
        surplus: data.FailureTime && new Date(data.FailureTime + "+08:00").diff(new Date()).day,// 有效天数(剩余过期天数)
      };
    },
    async setActiveCard(cards){ // 未激活卡提醒
      const LastActiveTipsDateStorageKey = 'active-tips-date';
      let today = new Date().format("yyyy-MM-dd");
      if(window.local.getValue(LastActiveTipsDateStorageKey) == today) return; // 今天已经提示

      let item;
      for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        if (card.status == 10 && card.audit != 10) {
          item = {
            card : card, 
            title : card.name,
            subTitle: null,
            icon: require('@/assets/ic_alert_expire.png'),
            message : '限时免费领取',
            okText: '我要领取',
            tipsType: 1,
            done: function() {
              window.local.saveValue(LastActiveTipsDateStorageKey, today);// 记录已经提示
            }
          };
          this.tips.push(item);
          return item;
        }
      }
    },
    async setRenewCard(cards){ // 需要续费的卡提醒(每天提醒一次)
      const LastRenewTipsDateStorageKey = 'renew-tips-date';
      let today = new Date().format("yyyy-MM-dd");
      if(window.local.getValue(LastRenewTipsDateStorageKey) == today) return; // 今天已经提示
      for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        if (card.status == 20) {
          let flag = await this.hasUsed(card.id);  //已使用过卡无需提醒
          if(!flag)
          {
            let item = {
              card: card, 
              title: '保护<br>即将到期',
              subTitle: '小主，真的要离开我了么？<br>好想一直保护你',
              icon: require('@/assets/ic_alert_expire.png'),
              message: card.name +'将于<span style="color:red">'+ (card.surplus || 0) +'</span>天后到期，到期后您的爱机不再享有手机碎屏保障',
              okText: '立即续费',
              tipsType: 2,
              done: function() {
                window.local.saveValue(LastRenewTipsDateStorageKey, today);// 记录已经提示
              }
            };
            this.tips.push(item);
            return item;
          }
        }
      }
    },
    async setExpiredCard(cards) { // 已过期卡提醒(提醒过的卡不再提醒)
      const ExpiredTipsItemsStorageKey = 'expired-tips-ids';
      let tipsItems = JSON.parse(window.local.getValue(ExpiredTipsItemsStorageKey)) || [];//已提醒过的过期卡ID
      for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        if (card.status == -10 && !tipsItems.find((d) => d == card.id)) {
          let flag = await this.hasUsed(card.id);  //已使用过卡无需提醒
          if(!flag) {
            let item = {
              card : card, 
              title : '过期提示',
              subTitle: '小主：',
              incon: '',
              message: card.name +' 已到期，您的爱机不再享有手机碎屏保障',
              okText: '我知道了',
              tipsType: 3,
              done: function() {
                let ids = JSON.parse(window.local.getValue(ExpiredTipsItemsStorageKey)) || [];//已提醒过的过期卡ID
                ids.push(card.id);
                window.local.saveValue(ExpiredTipsItemsStorageKey, JSON.stringify(ids));// 记录已经提示
              }
            };
            this.tips.push(item);
            return item;
          }
        }
      }
    },
    executeTips(){
      this.showTips = false;
      if(this.tips.length > this.currentTipsIndex) {
        setTimeout(() => {
          this.currentTipsMessage = this.tips[this.currentTipsIndex++];
          this.useAlert = this.currentTipsMessage.tipsType == 1 ? YActAlert : NormalAlert;
          this.showTips = true;
          if(this.currentTipsMessage.done){
            this.currentTipsMessage.done(); // 提示完成,记录已提示消息
          }
        }, 500);
      }
    },
    tipsDone() {
      let tipsType = this.currentTipsMessage.tipsType; // 提示类型
      let card = this.currentTipsMessage.card;
      switch(tipsType){
        case 1:
          this.$router.push({
            name: "CareActive",
            params: {
              code: card.code, // 无忧卡激活码
              type: card.type  // 卡类型
            },
            query:{
              name: card.name
            }});// 转向激活
          break;
        case 2:
          this.$router.push({
            name:"CareRenewPay",
            params: {
              id: card.id,
            },
            query: {
              type: card.type,
              name:card.name,
              time: card.endTime && card.endTime.getTime()
            }
          });
          break;
        case 3:
          console.log('tips done','已过期');
          break;
      }
    },
    async hasUsed(cardId){ // 查询是否有履约
      let used = false;
      try {
        const ret = await httpOpen("/WuYouCard/JudgeCardUseState", {
          type: "post",
          body: { CardSysNo: cardId },
        });
        used = ret.Status; // STATUS 表示是否已使用
        console.log(ret);
      } catch (e) {
        console.error(e);
      }
      return used;
    },
    async scanCareCardCode() {
      let res = await this.scanQRCode();
      const reg = /^[a-zA-Z]{6}[0-9]{6}$/;
      // const url = projectUrl + "/care/card/";
      if (res.indexOf("http://") === 0 || res.indexOf("https://") === 0) {
        this.goto(res);
      } else if (reg.test(res)) {
        // this.$toast("未识别该卡");
        this.goto("/care/card/" + res);
      } else {
        this.$toast("未识别该卡");
      }
    },
    gotoDetail(care) {
      //status: 10= 未激活，20=已激活，-10=已失效，-20=已作废
      //audit: -1=未提交审核，10=待审核，20=审核通过，30=审核失败
      if(care.status == -20)
      {
        this.$toast("该卡已作废");
        return; // 作废卡无法查看
      } 

      if(care.renewCard && (care.status == 20 || care.status == -10)) {
        this.gotoRenewDetail(care); // 已激活或已过期的续费卡转至续费卡详情页
      }else {
        this.$router.push("/care/" + care.id);
      }
    },
    gotoRenewDetail(card) {
      this.$router.push("/care/renew/" + card.id);
    },
    activateCareDialogCallback() {
      this.showActivateCareDialog = false;
    },
    activate() {
      this.showActivateCareDialog = true;
    },
    goAd() {
      this.goto("https://r.piseneasy.com/pro/page/114");
    },
    tabSwitch(index) {
      if (this.currentTabIndex != index) {
        this.currentTabIndex = index;
        this.goto(TabRoutePath[index]);
      }
    }
  },
};
</script>
<style lang="less" scoped>
.my-care {
  .nav-menu{
    position: fixed;
    display: flex;
    bottom: 0;
    left: 0;
    right: 0;
    height: 47px;
    background-color: #fff;
    align-items: center;
    z-index: 10;
    box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.11);
    font-weight: 600;
    >span{
      flex: 1;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60%;
      font-size: 14px;
      color: #111111;
      &:not(:first-child){
        border-left: 1px solid #cbcbcb;
      }
      .nav-care-menu-ico-1{
        display: inline-block;
        width: 30px;
        height: 22px;
        background: url("~@/assets/nav-care-menu-ico-1.png") 0 0 no-repeat;
        background-size: 100%;
        margin-right: 10px;
      }
      .nav-care-menu-ico-2{
        display: inline-block;
        width: 23px;
        height: 24px;
        background: url("~@/assets/nav-care-menu-ico-2.png") 0 0 no-repeat;
        background-size: 100%;
        margin-right: 10px;
      }
      &.actived{
        .nav-care-menu-ico-1{
          background: url("~@/assets/nav-care-menu-ico-1-actived.png") 0 0 no-repeat;
          background-size: 100%;
        }
        .nav-care-menu-ico-2{
          background: url("~@/assets/nav-care-menu-ico-2-actived.png") 0 0 no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
</style>
